/**
 * ? @description : Mapped Tab
 */

// Dependencies
import React, { useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Dropdown } from "react-bootstrap";
import { useDispatch } from "react-redux";
import Chip from "@material-ui/core/Chip";
import { CircularProgress, Typography } from "@mui/material";

// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Components
import MappedModalDelete from "./modals/MappedModalDelete";
import CommentsModal from "../../../Reusable/CommentsModalReuse";

// Axios Component
import Axios from "../../../../axios/Axios";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";
import { ShowFullText } from "../../../Reusable/ShowMoreText";
import axios from "axios";


function MappedTab() {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [data, setData] = useState([]);
  const [mappedData, setMappedData] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [isDataFetchError, setIsDataFetchError] = useState(false);

   // for comment section 
   const [reloadComments, setReloadComments] = useState(false);
   const handleCommentsModalClose = () => {
     setReloadComments(!reloadComments);
   };
   // for pagination state 
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const handleRowsPerPageChange = (newRowsPerPage) => {
    setRowsPerPage(newRowsPerPage);
  };
  // * Columns Declaration for Table
  const columns = [
    {
      name: "map_id",
      label: "Mapped Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
        sort: true,
        sortDirection: "desc"
      },
    },
    {
      name: "teacher_id",
      label: "Teacher Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "teacher_name",
      label: "Teacher Name",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_id",
      label: "Student Id",
      options: {
        display: false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_name",
      label: "Student Name",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    // {
    //   name: "batch_id",
    //   label: "Batch Id",
    //   options: {
    //     filter: false,
    //     filterType: "dropdown",
    //   },
    // },
    // {
    //   name: "batch_name",
    //   label: "Batch Name",
    //   options: {
    //     filter: true,
    //     filterType: "dropdown",
    //   },
    // },
    {
      name: "spoc_id",
      label: "SPOC Id",
      options: {
        filter: false,
        filterType: "dropdown",
        display: false, 
      },
    },
    {
      name: "spoc_name",
      label: "SPOC Name",
      options: {
        filter: true,
        filterType: "dropdown",
      },
    },
    {
      name: "comment_desc",
      label: "Comments",
      options: {
        filter: true,
        filterType: "dropdown",
        customBodyRender :(value) =>{
          // console.log(value);
          return (
            <ShowFullText title={value}>
             <Typography variant='p' sx={{ cursor:'pointer'}}>
              {value && value.length> 25? `${value.substring(0,25)}...` : value}
             </Typography>
            </ShowFullText>
          )
        }
      },
    },
    
    {
      name: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        customBodyRenderLite: () => {
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#" onClick={() => setCommentModal(true)}>
                    Create / View comment
                  </Dropdown.Item>

                  <Dropdown.Item href="#" onClick={() => setDeleteModal(true)}>
                    Unmap
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    },
  ];


  // * Function Call
  useEffect(() => {
    // ? Get Method : Get Mapped Data from Server
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        let options = {
          method: "GET",
          url: "/mapping",
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
      response.status === 200 && response.data.length !== 0 ? setMappedData(response.data) : setIsDataFetchError(true)
       
      } catch (error) {
        if (!axios.isCancel(error)){
          setIsDataFetchError(true)
          dispatch(
            showSnackbar({
              message: "Unable to get mapped data.",
              severity: "error",
            })
          );
        }
      }
    })()
    return () => {
      controller.cancel();
  }
  }, [dispatch,reloadComments,rowsPerPage]);

  // * Options Configuration for Table
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange ,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    jumpToPage: true,
    onRowClick: (rowData, rowState) => {
      setData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
          if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
          }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };

  return (
    <div style={{ padding: "10px" }}>
      {/* Table */}
      <MUIDataTable
        title={"Mapped Data"}
        data={mappedData}
        columns={columns}
        options={options}
        components={{
          TableFilterList: CustomFilterList,
        }}
      />

      {/* Modal */}
      <MappedModalDelete
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        tabledata={data}
        onCloseCallback ={handleCommentsModalClose}
      />

      {/*Comments modal*/}
      <CommentsModal
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={tableData}
        tabledata={data}
        modalname="mappingcomments"
        postcomment={"comments/map"}
        getcomment={"comments/map/mapping/"}
        onCloseCallback ={handleCommentsModalClose}
      />
    </div>
  );
}

export default MappedTab;
